import React, { useEffect, useState } from 'react';
import { Message } from '@kvdbil/components';
import { useTranslation } from '~/Locale';
import StatusPageLoading from '~/App/shared/components/StatusPageLoading';
import OrganisationMemberDetailsForm, {
  FormData
} from './OrganisationMemberDetailsForm';
import { useMemberDataUpdate } from '../../hooks/useMemberDataUpdate';
import { usePrevious } from '~/App/shared/hooks/usePrevious';

interface Props {
  handleClose(): void;
}

const BiddingOrgMemberDataVerification = ({ handleClose }: Props) => {
  const { t } = useTranslation();
  const [organisationDetailsFormData, setOrganisationDetailsFormData] =
    useState<FormData | null>(null);
  const {
    saveAccountDetailsCallback,
    isSavingAccountDetails,
    isSavingAccountDetailsError
  } = useMemberDataUpdate();
  const previousIsSavingAccountDetails = usePrevious<undefined | boolean>(
    isSavingAccountDetails
  );

  useEffect(() => {
    if (
      previousIsSavingAccountDetails &&
      !isSavingAccountDetails &&
      !isSavingAccountDetailsError
    ) {
      handleClose();
    }
  }, [
    previousIsSavingAccountDetails,
    isSavingAccountDetails,
    isSavingAccountDetailsError,
    handleClose
  ]);

  if (isSavingAccountDetails || isSavingAccountDetailsError) {
    return (
      <>
        {isSavingAccountDetails && <StatusPageLoading />}
        {isSavingAccountDetailsError && (
          <Message type="error" fullWidth>
            {t('Something went wrong, please try again later.')}
          </Message>
        )}
      </>
    );
  }

  return (
    <OrganisationMemberDetailsForm
      organisationDetailsFormData={organisationDetailsFormData}
      setOrganisationDetailsFormData={setOrganisationDetailsFormData}
      handleSubmitButtonClick={formData => saveAccountDetailsCallback(formData)}
      accountVerificationStatus="VERIFY_ORG_MEMBER_DATA"
    />
  );
};

export default BiddingOrgMemberDataVerification;
